import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { langType, withLang } from '../../../i18n';
import {
  navigateTo
} from '../../../util';

const CloseSurveyIconButton = ({
  route, surveyId, translate: t, disabled
}) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="actionButton icon--item-close"
      title={t('survey.close')}
      onClick={() => navigateTo(navigate, route, surveyId)}
      disabled={disabled}
      data-cy="close-survey-icon-button"
    />
  );
};
const {
  string
} = PropTypes;

CloseSurveyIconButton.propTypes = {
  surveyId: string.isRequired,
  ...langType
};

export default withLang(CloseSurveyIconButton);
